import type { FundSelection } from '@festina/unitlink-general-types/unitlink'
import { notEmpty, typeUtils, type ValidatedKey } from '@festina-life/core'
import {
  FormikPercentageInput,
  FormikSelect,
} from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useHook } from '../../../lenteHooks'

type Props = {
  fieldNamePrefix: ValidatedKey
}

export const FundSelectionForm = ({ fieldNamePrefix }: Props) => {
  const tenantId = useHook('routing.tenant.useTenantParam')()
  const { data: funds } = useHook('fetchers.unitlink.useFetchFunds')({
    tenantId,
  })
  const allFunds = funds?.fundItems?.filter(notEmpty) ?? []
  const allIsinKeys = allFunds.map((item) => item.isinKey).filter(notEmpty)

  const translate = useTranslate()

  const validateKey =
    typeUtils.createNestedValidator<FundSelection>(fieldNamePrefix)

  return (
    <>
      <FormikSelect
        name={validateKey('isinKey')}
        options={allIsinKeys}
        label={translate('switchTradeModalButton.fundSelection.isinKey')}
        renderFn={(isinKey) =>
          allFunds?.find((fund) => fund.isinKey === isinKey)?.name
        }
        isRequired
      />
      <FormikPercentageInput
        name={validateKey('fraction')}
        label={translate('switchTradeModalButton.fundSelection.percentage')}
        isRequired
      />
    </>
  )
}
